import React from 'react';
import { observer } from 'mobx-react-lite';
import { CalculatorUI } from '../features/calculator/ui/calculator-ui';

export const CalculatorObserver: React.FC = observer(() => {
  return <CalculatorUI />;
});
